<template>
  <transition name="bbe-bounce">
    <div class="bbe-popup-list" v-if="show">
      <div class="bbe-popup-list__option" v-for="{title, action} of options" :key="title" @click="action">
        {{ title }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PopupWithOptions',
  props: ['options', 'show']
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-popup-list {
  @include global-font;
  display: inline-block;
  position: absolute;
  background: $color-white;
  box-shadow: 0 0 10px rgba($color-accent, 0.14);
  border-radius: 4px;
  overflow: hidden;

  &__option {
    padding: 12px;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: $color-black;
    user-select: none;
    white-space: nowrap;
    border-bottom: 1px solid $color-alabaster;
    transition: 0.3s;

    &:last-child {
      border-bottom: 1px solid transparent;
    }

    &:hover {
      background-color: $color-alabaster;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/PopupWithOptions/PopupWithOptions.vue